
export class MultiManagePasswordGroupMembershipEntry {
    gid: number;
    id: number;
    gk: string;
    action: number;
}